import { HomeOutlined } from "@ant-design/icons";
import styles from "./profile.module.scss";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Button, Col, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import { SwitchStateMsisdn } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import { useState } from "react";
const Profile = ({ Profile, state = false }) => {
	const [t] = useTranslation("global");
	const { queryMSCAddress } = useDealer();
	const nav = useNavigate();
	const [network, setNetwork] = useState({
		operator: "",
		isLoading: false,
	});
	const inquiryHandler = async () => {
		setNetwork((net) => ({ ...net, isLoading: true }));
		const payload = {
			msisdn: Profile?.inT_MSISDN,
		};
		const responseInquiry = await queryMSCAddress(payload);
		if (responseInquiry) {
			setNetwork((net) => ({ ...net, operator: responseInquiry }));
		}
		setNetwork((net) => ({ ...net, isLoading: false }));
	};
	console.log(Profile);
	return (
		<>
			<div className={styles.profile}>
				<div className={styles.row}>
					<div className={styles.prof_role}>
						<div className={styles.row_item}>
							<div className={styles.avatar}>
								<i className="icon-user"></i>
							</div>
							<div className={styles.text_prof}>
								<span className={styles.name}>{`${Profile?.stR_FName}`}</span>
								<div className={styles.row_name}>
									<h3>{Profile?.inT_MSISDN}</h3>
									<div className={`${styles.state} ${styles.success} ${styles.fail}`}>{SwitchStateMsisdn(Profile?.inT_MSISDNStatusType)}</div>
									<div className={`${styles.sim_state}`}>سیم کارت {Profile?.inT_MSISDNSimcardType ? "دائمی" : "اعتباری"}</div>
								</div>

								{network.operator && (
									<div className={styles.has_sim}>
										شماره {Profile?.inT_MSISDN} هم اکنون از شبکه {network.operator} پوشش می گیرد
									</div>
								)}
							</div>
						</div>
					</div>
					<div className={styles.action_role}>
						<div className={`holder-button ${styles.hold_button}`}>
							{!state && (
								<Button onClick={() => inquiryHandler()} className={`btn-normal btn-green`} disabled={network.isLoading}>
									استعلام شبکه کنونی موبایل
								</Button>
							)}
							<Button onClick={() => nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search)} className={`btn-normal`}>
								بازگشت
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Profile;
